import API, { type ApiOptions } from '@/api/base';

export interface LoginBody {
  username: string;
  password: string;
}

export const Authorization = {
  checkSession: async () => {
    const options: ApiOptions = {
      method: 'GET',
      url: 'session/'
    };

    return await API.request(options);
  },
  login: async (data: LoginBody) => {
    const options: ApiOptions = {
      method: 'POST',
      url: 'login/',
      data
    };

    return await API.request(options);
  },
  logout: async () => {
    const options: ApiOptions = {
      method: 'POST',
      url: 'logout/'
    };
    return await API.request(options);
  }
};
